import {z} from 'zod';

import type {ZodType, ZodTypeDef} from 'zod';

export const isValueOf = <T>(x: ZodType<T, ZodTypeDef>, y: unknown): y is T =>
  x.safeParse(y).success;

export const ensureValueOf: <T>(x: ZodType<T, ZodTypeDef>, y: unknown) => asserts y is T = (
  x,
  y
) => {
  // デバッグの便利のため型のどこが不整合になっているか情報を上げたいのでparse直接使用
  x.parse(y);
};

export const requireValueOf = <T>(x: ZodType<T, ZodTypeDef>, y: unknown): T => {
  ensureValueOf(x, y);
  return y;
};

// const language = { Ascii: 'A', Basic: 'B'} as const みたいなオブジェクトのKeyのunion型をzodでつかえるようにするメソッド
export const objectToKeyArray = <TKey extends string, TValue>(
  obj: Record<TKey, TValue>
): [TKey, ...TKey[]] => {
  const keys = Object.keys(obj) as TKey[];
  const first = keys[0];
  if (first === undefined) {
    throw new Error('objectToKeyArray: Object.keys(obj)[0] is undefined.');
  }

  //  z.enumは空でない配列を期待するので、それを回避するために
  return [first, ...keys.slice(1)];
};

// const language = { 0: 'ja', 1: 'en'} as const みたいなオブジェクトのValueのunion型をzodでつかえるようにするメソッド
export const objectToValueArray = <T>(obj: {[key: number]: T}): [T, ...T[]] => {
  const first = obj[0];
  if (first === undefined) {
    throw new Error('objectToValueArray: obj[0] is undefined.');
  }

  //  z.enumは空でない配列を期待するので、それを回避するために
  return [
    first,
    ...Object.values(obj)
      .slice(1)
      .map((v) => v)
  ];
};

// TODO: coerce使った方がいいかもしれない
/**
 * 雑多に整数値を表す。
 *
 * NOTE:
 * RoomAPI [[@/repositories/roomRepository]] は全プロジェクト共通で用いられているので、突然仕様が変わったりするらしい。
 * つまり2022-03-28現在はstringで整数値が返ってくるが、将来的に突然numberで返ってくるかもしれないらしい。
 * それを対処するために、これを使用する。
 */
export const integral = z.number().or(z.string());

/** z.infer した結果に readonly を付けるためのヘルパー。渡した objectSchema 以上の検証はしない */
export const makeSchemaReadOnly = <T>(objectSchema: ZodType<T, ZodTypeDef>) =>
  z.custom<Readonly<T>>((x) => objectSchema.safeParse(x).success);
